import { loadSchemaAsText, Schema } from '../client/schema'
import { getIsServerSide } from './getIsServerSide'

const getSchemaJson = () => {
    if (getIsServerSide()) {
        return undefined
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const modelBase64 = process.env.NODE_ENV === 'production' ? window.__APP_MODEL__ : BASE64_MODEL_CONTENT || ''
    return Buffer.from(modelBase64, 'base64').toString()
}

const modelJSON = getSchemaJson()
export const schema = modelJSON ? loadSchemaAsText(modelJSON) : ({ models: {} } as Schema)
